<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.sharedStatus"
        placeholder="共享状态"
        clearable
      >
        <el-option
          v-for="(item, i) in sharedStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.onlineStatus"
        placeholder="上线状态"
        clearable
      >
        <el-option
          v-for="(item, i) in onlineList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.setTop"
        placeholder="置顶状态"
        clearable
      >
        <el-option
          v-for="(item, i) in topList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.noticeTitle"
        placeholder="公告标题"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
export default {
  components: {
    butn,
  },
  data() {
    return {
      filters: {},
      onlineList: [],
      topList: [],
      sharedStatusData: [],
    };
  },
  created() {
    this.getSysParamByTypes(["ONLINE_STATUS", "IS_VALID", "SHARED_SCREEN_STATUS"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        this.onlineList = res.data["ONLINE_STATUS"];
        this.topList = res.data["IS_VALID"];
        this.sharedStatusData = res.data["SHARED_SCREEN_STATUS"] || [];
      });
    },
    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>
